import WsService from "../WsService";
import UserSessionService from "../UserSessionService";

const ENDPOINT_BASE = "/payments";

export default class CardPaymentService {

    static requestPayment(paymentReference) {

        let endpoint = ENDPOINT_BASE + "/" + paymentReference + "/request";

        let cardPaymentHeaders = UserSessionService.retrieveCardPaymentHeaders();

        let headers = {
            ...cardPaymentHeaders
        };

        return WsService.postWithHeaders(endpoint, {}, 201, headers).then(
            response => {
                return response;
            },
            response => {
                return response;
            });
    }
}
